import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import RootStyles, {
  Section, Content, Footer,
} from './root_styles';
import ContactForm from '../hub_spot_form/components/contact_form';
import MaterialIcon, {colorPalette} from 'material-icons-react';

const propTypes = {
  page: PropTypes.shape({}).isRequired,
  faqs: PropTypes.shape({}).isRequired,
  fork: PropTypes.shape({}).isRequired,
  knife: PropTypes.shape({}).isRequired,
  spoon: PropTypes.shape({}).isRequired,
  dork: PropTypes.shape({}).isRequired,
  modal: PropTypes.shape({}).isRequired,
  buyNow: PropTypes.shape({}).isRequired,
  hideModal: PropTypes.shape({}).isRequired,
  modalContent: PropTypes.shape({}).isRequired,
  setTitle: PropTypes.shape({}).isRequired,
};

const defaultProps = {
};

const RootView = ({
  page, faqs, fork, knife, spoon, dork, modal, buyNow, hideModal, modalContent, setTitle,
}) => (
  <RootStyles>

    <Modal
      isOpen={modal === 'buy-now'}
      onRequestClose={hideModal}
      className="modal"
      overlayClassName="overlay"
    >
      <div className="close-modal">
        <MaterialIcon icon="cancel" onClick={hideModal} />
      </div>
      <div>
        <h1>{ modalContent && modalContent.get('title') }</h1>
        <ContactForm />
        <div style={{ clear: 'both', height: 40 }} />
        <div dangerouslySetInnerHTML={{ __html: modalContent && modalContent.get('body') }} />
      </div>
    </Modal>

    <Section className="dark fork" backgroundColor="#111">
      <Content>
        <div className="row">
          <div className="col-md-7">
            <div className="mobile-only" style={{ margin: -40, marginBottom: 30 }}>
              <img src="/assets/og-image.jpg" width="100%" alt="bitcoin fork" />
            </div>
            <h1>{ page && page.get('header') }</h1>
            <h2>{ page && page.get('subhead') }</h2>
            <a id="buy-now-top" className="btn but-now" onClick={buyNow}>
              Buy Now
              {' '}
              <b>$20</b>
            </a>
          </div>
        </div>
      </Content>
    </Section>

    <Section className="faqs">
      <Content>
        { modal }
        <h1>FAQs</h1>
        <div className="row">
          { faqs && faqs.size > 0 && faqs.valueSeq().map(faq => (
            <div key={faq.get('question')} className="col-sm-4">
              <div className="faq">
                <h2>{faq.get('question')}</h2>
                <div className="answer" dangerouslySetInnerHTML={{ __html: faq.get('answer') }} />
              </div>
            </div>
          )) }
        </div>
      </Content>
    </Section>

    <Section className="the-set">
      <Content>
        <h1>{ setTitle && setTitle.get('title') }</h1>
        <div className="row">
          <div className="col-sm-4">
            <div className="img fork" />
            <h2>{ fork && fork.get('title') }</h2>
            <div className="answer" dangerouslySetInnerHTML={{ __html: (fork && fork.get('body')) }} />
          </div>
          <div className="col-sm-4">
            <div className="img knife" />
            <h2>{ knife && knife.get('title') }</h2>
            <div className="answer" dangerouslySetInnerHTML={{ __html: (knife && knife.get('body')) }} />
          </div>
          <div className="col-sm-4">
            <div className="img spoon" />
            <h2>{ spoon && spoon.get('title') }</h2>
            <div className="answer" dangerouslySetInnerHTML={{ __html: (spoon && spoon.get('body')) }} />
          </div>
        </div>
      </Content>
    </Section>

    <Section className="dark triton" backgroundColor="#333">
      <Content>
        <center>
          <h1>{ dork && dork.get('title') }</h1>
          <div className="dork-subhead" dangerouslySetInnerHTML={{ __html: (dork && dork.get('body')) }} />
          <a id="buy-now-bottom" className="btn but-now" onClick={buyNow}>
            Buy Now
            {' '}
            <b>$20</b>
          </a>
        </center>
      </Content>
    </Section>
    <Footer>
      &copy; 2018 Bitcoin Fork Gifts. All Rights Reserved.
    </Footer>

  </RootStyles>
);

RootView.propTypes = propTypes;
RootView.defaultProps = defaultProps;

export default RootView;



// WEBPACK FOOTER //
// ./src/root/root_view.js